// extracted by mini-css-extract-plugin
export default {"downloadBlock":"Yy30f","qrCode":"DNAeT","qrCodeWrapper":"DguF0","title":"_6SXaP","titleThin":"tahj9","downloadButton":"hu7z-","skeleton-progress":"PgRDF"};